module.exports = __webpack_public_path__ + "logo.svg?f739aca34ac867c0d1977d256c4a8d13";